import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  root: {
    overflowY: "auto",
  },
  dataGridTable: {
    "& .MuiDataGrid-columnHeaders": {
      background: "#1D426D33",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 400,
      textTransform: "uppercase",
      fontSize: 12,
    },
    "& .MuiDataGrid-iconSeparator": {
      color: "#000 !important",
    },
    "& .MuiDataGrid-virtualScroller": {
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": {
        height: 8,
      },
    },
  },
  lightText: {
    "& .MuiTypography-root": {
      color: "rgba(0, 0, 0, 0.7)",
    },
  },
  iconsWrapper: {
    display: "flex",
    gap: 8,
    alignItems: "center",
  },
  addBtn: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px 20px",
  },
  funBtn: {
    padding: "10px 6px !important",
  },
  statusActive: {
    display: "inline-block",
    padding: "2px 10px",
    borderRadius: 12,
    background: "#e6f4ea",
    color: "#2e7d32",
    fontSize: 12,
    fontWeight: 600,
  },
  statusInactive: {
    display: "inline-block",
    padding: "2px 10px",
    borderRadius: 12,
    background: "#fdecea",
    color: "#c62828",
    fontSize: 12,
    fontWeight: 600,
  },
}));

export default useStyles;
